import { Button, type ButtonProps, cn } from '@sr/ui-library';

/**
 * Figma-aligned preset for icon-only file download buttons (Royalties ANZ,
 * Title Summary, etc.). Callers pass the file glyph via `sectionLeft`.
 */
export const RoyaltyFileDownloadButton = ({
  className,
  disabled,
  ...props
}: ButtonProps) => (
  <Button
    className={cn(`size-8 text-ui-danger`, className)}
    disabled={disabled || props.loading}
    iconSize="xl"
    size="content"
    variant="transparent"
    {...props}
  />
);
